import { FormatLabelFn } from '@@partner:types:app'

import {
  CUSTOMER_STATUS_DISABLED,
  CUSTOMER_STATUS_ENABLED,
  CUSTOMER_STATUS_DELETED
} from '../../config/customer'

export const formatCustomerStatus: FormatLabelFn = (status) => {
  switch (status) {
  case CUSTOMER_STATUS_DISABLED:
    return { label: 'Заблокирован', color: 'orange' }
  case CUSTOMER_STATUS_ENABLED:
    return { label: 'Активный', color: 'cyan' }
  case CUSTOMER_STATUS_DELETED:
    return { label: 'Удалён', color: 'red' }
  default:
    return { label: 'Неопределённый статус!', color: 'red' }
  }
}
